import client from '/src/services/client.js';

export default {
    getPoles: () => client.get('api/poles'),
};
